import moment from 'moment';
import { Data, Brand } from 'effect';

export const ALLOCATION_PANEL_AS_OF_DATE_DATE_FORMAT = 'MM/DD/YYYY';

export type FormattedDateString = string & Brand.Brand<'AsOfDate'>;
export const FormattedDateString = Brand.refined<FormattedDateString>(
  (value) => moment.utc(value, ALLOCATION_PANEL_AS_OF_DATE_DATE_FORMAT).isValid(),
  (value) => Brand.error(`Expected value ${value} to be of format ${ALLOCATION_PANEL_AS_OF_DATE_DATE_FORMAT}`, value),
);

export type AsOfDateSetting = Data.TaggedEnum<{
  Current: {};
  LastUploaded: {};
  Date: { date: FormattedDateString };
}>;
export const AsOfDateSetting = Data.taggedEnum<AsOfDateSetting>();
